/* eslint-disable array-callback-return */
import * as yup from "yup";
import regEx from "./regularExpression";
import { formatFieldError } from "../utils/formatter";
import dayjs from "dayjs";
import moment from "moment";
// const SUPPORTED_FORMATS = [
//   "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//   "application/pdf",
// ];

const validationSchema: any = {
  username: yup
    .string()
    .test(
      "betweenSpaces",
      "The username has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(2, "Username must be more than 2 characters")
    .max(30, "Username cannot exceed more than 30 characters")
    .required("Username is a required field"),
  password: yup
    .string()
    .transform((value) => (typeof value === "string" ? value.trim() : value))
    .test(
      "betweenSpaces",
      "Password has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    // .min(8, "Password must be more than 8 characters")
    // .max(16, "Password cannot exceed more than 16 characters")
    .required("Password is a required field"),

  newPassword: yup
    .string()
    .required("New password is a required field")
    .test(
      "betweenSpaces",
      "New password has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    ),
  // .matches(regEx.password, "New password is too weak"),
  confirmPassword: yup
    .string()
    .required("Confirm password is a required field")
    .test(
      "betweenSpaces",
      "Conform password has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .oneOf([yup.ref("newPassword")], "Confirm passwords must match"),
  firstName: yup
    .string()
    .test(
      "betweenSpaces",
      "First name has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(2, "First name must be more than 2 characters")
    .max(30, "First name cannot exceed more than 30 characters")
    .required("First name is a required field")
    .matches(regEx.alphabetsOnly, "First name can only contain alphabets"),
  lastName: yup
    .string()
    .matches(regEx.alphabetsOnly, "Last name can only contain alphabets")
    .test(
      "betweenSpaces",
      "Last name has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(1, "Last name must be more than 1 characters")
    .max(30, "Last name cannot exceed more than 30 characters")
    .required("Last name is a required field"),
  email: yup
    .string()
    .transform((value) => (typeof value === "string" ? value.trim() : value))
    .test(
      "betweenSpaces",
      "Email address has an excessive number of intermediate spaces",
      (value: any) => {
        if (!value.trim()) {
          return false;
        }
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .matches(regEx.email, "Invalid email address format")
    .min(2, "Email address must be more than 2 characters")
    .max(100, "Email address cannot exceed more than 100 characters")
    .required("Email address is a required field"),

  phone: yup
    .string()
    .matches(/^\d+$/, "Phone number must only contain numbers")
    .matches(
      /^[1-9]\d{9}$/,
      "Phone number must be exactly 10 digits and cannot start with 0"
    )
    .required("Phone number is a required field")
    .trim(),
  //   .string()
  //   .matches(/^[1-9]\d*$/, "Phone number must only contain numbers and cannot start with 0")
  //   .length(10, "Phone number must be exactly 10 digits")
  //   .required("Phone number is a required field")
  //   .trim(),

  bloodGroup: yup.string().required("Blood group is a required field"),
  reportName: yup.string().required("Report name is a required field"),
  time: yup.string().required("Time is a required field"),
  gender: yup.string().required("gender is a required field"),
  categoryId: yup.string().required("Category is a required field"),
  status: yup.string().required("Status is a required field"),

  employeeCode: yup
    .string()
    .trim()
    .required("Employee code is a required field"),
  homePoint: yup.string().trim().required("Please select a location"),
  roleID: yup.object().required("Role is a required field"),
  locationID: yup.object().required("Zone is a required field"),
  commonPointID: yup.object().required("Common point is a required field"),
  landmark: yup
    .string()
    .required("Landmark is a required field")
    .min(2, "Landmark must be more than 2 characters"),
  joinedDate: yup.string().required("Joining date is a required field"),
  address: yup
    .string()
    .trim()
    .required("Address is a required field")
    .min(2, "Address must be more than 2 characters")
    .max(150, "Address cannot exceed more than 150 characters"),
  emergencyContactNo: yup
    .string()
    .matches(/^\d+$/, "Emergency contact number must only contain numbers")
    .matches(
      /^[1-9]\d{9}$/,
      "Emergency contact number must be exactly 10 digits and cannot start with 0"
    )
    .required("Emergency contact number is a required field")
    .trim(),
  emergencyContactName: yup
    .string()
    .trim()
    .required("Emergency contact name is a required field"),
  securityCode: yup
    .string()
    .trim()
    .required("Security code is a required field"),
  managerId: yup.object().required("First name is a required field"),
  currency: yup.object().required("Currency is a required field"),
  countryCode: yup.string().required("Country is a required field"),
  ruleLevel: yup.string().required("Rule level is a required field"),
  timeZone: yup.object().required("Time zone is a required field"),
  cityID: yup.number().required("City is a required field"),
  vendorID: yup.number().required("Vendor is required"),
  customers: yup.array().of(
    yup.object({
      customerId: yup
        .string()
        // .matches(regEx.alphabetsOnly, "Name can only contain alphabets")
        .required("Customer id is a required field"),
      customerName: yup
        .string()
        // .matches(regEx.alphabetsOnly, "Name can only contain alphabets")
        .required("Customer name is a required field"),
    })
  ),
  updateHotelAsset: yup
    .array()
    .of(
      yup.object({
        criterionCase: yup.string(),
        bidModifierValue: yup
          .string()
          .required("Bid modifier value is a required field"),
        minNights: yup
          .number()
          .test(
            "minNights-required",
            "Number of nights is a required field",
            function (value) {
              const { criterionCase } = this.parent;
              if (
                criterionCase === "HotelLengthOfStay" &&
                (value === undefined || value === null || value === 0)
              ) {
                return false;
              }
              return true;
            }
          ),
        maxNights: yup
          .number()
          .test(
            "maxNights-required",
            "Number of nights is a required field",
            function (value) {
              const { criterionCase } = this.parent;
              if (
                criterionCase === "HotelLengthOfStay" &&
                (value === undefined || value === null || value === 0)
              ) {
                return false;
              }
              return true;
            }
          )
          .test(
            "maxNights-check",
            "Max Nights must be greater than or equal to Min Nights",
            function (value: any) {
              const { criterionCase, minNights } = this.parent;
              if (criterionCase === "HotelLengthOfStay" && minNights > value) {
                return false;
              }
              return true;
            }
          ),
        minDays: yup
          .number()
          .test(
            "minDays-required",
            "Number of days is a required field",
            function (value) {
              const { criterionCase } = this.parent;
              if (
                criterionCase === "HotelAdvanceBookingWindow" &&
                (value === undefined || value === null)
              ) {
                return false;
              }
              return true;
            }
          ),
        maxDays: yup
          .number()
          .test(
            "maxDays-required",
            "Number of days is a required field",
            function (value) {
              const { criterionCase } = this.parent;
              if (
                criterionCase === "HotelAdvanceBookingWindow" &&
                (value === undefined || value === null)
              ) {
                return false;
              }
              return true;
            }
          )
          .test(
            "maxDays-check",
            "Max Days must be greater than or equal to Min Days",
            function (value: any) {
              const { criterionCase, minDays } = this.parent;
              if (
                criterionCase === "HotelAdvanceBookingWindow" &&
                minDays > value
              ) {
                return false;
              }
              return true;
            }
          ),
        startDate: yup
          .string()
          .nullable()
          .test(
            "startDate-required",
            "Date range is a required field",
            function (value) {
              const { criterionCase } = this.parent;
              if (
                criterionCase === "HotelCheckInDateRange" &&
                (value === undefined || value === null)
              ) {
                return false;
              }
              return true;
            }
          ),
        endDate: yup
          .string()
          .nullable()
          .test(
            "endDate-required",
            "Date range is a required field",
            function (value) {
              const { criterionCase } = this.parent;
              if (
                criterionCase === "HotelCheckInDateRange" &&
                (value === undefined || value === null)
              ) {
                return false;
              }
              return true;
            }
          )
          .test(
            "endDate-check",
            "End date must be greater than or equal to Start date",
            function (value: any) {
              const { criterionCase, startDate } = this.parent;
              if (
                criterionCase === "HotelCheckInDateRange" &&
                startDate > value
              ) {
                return false;
              }
              return true;
            }
          ),
      })
    )
    .test(
      "non-overlapping-ranges",
      "Ranges should not overlap",
      function (criteria: any) {
        const { path, createError } = this;
        let errors: any[] = [];
        let min, max, min1, max1, min2, max2, messageItem;
        if (criteria[0]?.criterionCase === "HotelLengthOfStay") {
          min = "minNights";
          max = "maxNights";
          messageItem = "number of nights";
        }
        if (criteria[0]?.criterionCase === "HotelAdvanceBookingWindow") {
          min = "minDays";
          max = "maxDays";
          messageItem = "number of days";
        }
        if (criteria[0]?.criterionCase === "HotelCheckInDateRange") {
          min = "startDate";
          max = "endDate";
          messageItem = "date ranges";
        }
        if (criteria[0]?.criterionCase !== "HotelCheckInDay") {
          for (let i = 0; i < criteria?.length; i++) {
            for (let j = i + 1; j < criteria?.length; j++) {
              min1 = criteria[i]?.[min ?? ""];
              max1 = criteria[i]?.[max ?? ""];
              min2 = criteria[j]?.[min ?? ""];
              max2 = criteria[j]?.[max ?? ""];

              // Check if range i (min1-max1) overlaps with range j (min2-max2)
              if (
                (min1 <= max2 && max1 >= min2) || // Overlap condition
                (min2 <= max1 && max2 >= min1)
              ) {
                // Generate an error specific to the index where overlap is found
                errors.push(
                  createError({
                    path: `${path}[${j}][${min}]`,
                    message: `This ${messageItem} already has a bid adjustment`,
                  }),
                  createError({
                    path: `${path}[${j}][${max}]`,
                    message: `This ${messageItem} already has a bid adjustment`,
                  })
                );
              }
            }
          }
        }
        // If any errors were collected, return them as a batch
        if (errors.length > 0) {
          return new yup.ValidationError(errors);
        }
        return true;
      }
    ),
  labelObject: yup.object({
    name: yup.string().required("Customer id is a required field"),
    backgroundColor: yup.string().required("Customer name is a required field"),
  }),
  employeeType: yup.string().required("Employee type is a required field"),
  customerId: yup.array().min(1, "Customers is a required field"),
  campaignId: yup.array().min(1, "Campaigns is a required field"),
  ruleSet: yup.object().shape({
    conditions: yup.array().of(
      yup.object({
        name: yup.string().required("Condition name id is a required field"),
        operator: yup.string().required("Operator is a required field"),
        threshold: yup.string().required("Threshold is a required field"),
      })
    ),
    // .min(1, "Conditions is a required field"),
    actions: yup
      .array()
      .of(
        yup.object({
          actionType: yup.string().required("Action is a required field"),
        })
      )
      .min(1, "Actions is a required field"),
  }),
  usingDataFrom: yup.string().required("using data from is a required field"),
  deviceLevel: yup.string().required("Apply to is a required field"),
  startTime: yup.string().required("Time is a required field"),
  frequency: yup.string().required("Frequency is a required field"),
  phone1: yup
    .string()
    .matches(/^\d+$/, "Phone number must only contain numbers")
    .matches(
      /^[1-9]\d{9}$/,
      "Phone number must be exactly 10 digits and cannot start with 0"
    )
    .required("Phone number is a required field")
    .trim(),
  phone2: yup
    .string()
    .matches(/^\d+$/, "Phone number must only contain numbers")
    .matches(
      /^[1-9]\d{9}$/,
      "Phone number must be exactly 10 digits and cannot start with 0"
    )
    .required("Phone number is a required field")
    .trim(),
  dob: yup
    .string()
    .required("Date of birth is required")
    .test("not-future", "Date of birth cannot be in the future", (value) => {
      if (!value) return true;
      return new Date(value) <= new Date();
    })
    .test("min-age", "Date of birth cannot be less than 18 years.", (value) => {
      if (!value) return true;
      const dobDate = new Date(value);
      const minDobDate = new Date(
        new Date().getFullYear() - 18,
        new Date().getMonth(),
        new Date().getDate()
      );
      return dobDate <= minDobDate;
    }),
  endDate: yup
  .string()
  .nullable()
  .required("End Date is required.")
  .test(
    "valid-date",
    "Please select a valid end date.",
    (value) => {
      if (!value) return false;
      return moment(value, "YYYY-MM-DD", true).isValid();
    }),
  // .notRequired()
  // .matches(regEx.dateMonth, "Date of birth must be in DD/MM format"),
  name: yup
    .string()
    .trim()
    // .matches(regEx.name, "Name can only contain alphabets")
    .test(
      "betweenSpaces",
      "Name has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(3, "Name must be more than 2 characters")
    .max(100, "Name cannot exceed more than 100 characters")
    .required("Name is a required field"),

  title: yup
    .string()
    .trim()
    // .matches(regEx.name, "Name can only contain alphabets")
    .test(
      "betweenSpaces",
      "Title has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(3, "Title must be more than 2 characters")
    .max(500, "Title cannot exceed more than 500 characters")
    .required("Title is a required field"),

  description: yup
    .string()
    .trim()
    // .matches(regEx.name, "Name can only contain alphabets")
    .test(
      "betweenSpaces",
      "Title has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(3, "Description must be more than 2 characters")
    .max(255, "Description cannot exceed more than 255 characters")
    .required("Description is a required field"),

  gstNo: yup.string().matches(regEx.gstRegex, "Invalid GST number format"),
  geoCode: yup
    .string()
    .required("Please select a location")
    .matches(/^[^a-zA-Z]*$/, "Letters are not allowed in coordinates"),

  empName: yup
    .string()
    .trim()
    // .matches(regEx.name, "Name can only contain alphabets")
    .test(
      "betweenSpaces",
      "Name has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(2, "Name must be more than 2 characters")
    .max(100, "Name cannot exceed more than 100 characters")
    .required("Name is a required field"),

  empEmail: yup
    .string()
    .test(
      "betweenSpaces",
      "Email address has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )

    .matches(regEx.email, "Invalid email address format")
    .min(2, "Email address must be more than 2 characters")
    .max(40, "Email address cannot exceed more than 40 characters")
    .required("Email address is a required field")
    .email("Email address has an excessive number of intermediate spaces"),

  empPhone: yup
    .string()
    .matches(/^\d+$/, "Phone number must only contain numbers")
    .matches(
      /^[1-9]\d{9}$/,
      "Phone number must be exactly 10 digits and cannot start with 0"
    )
    .required("Phone number is a required field")
    .trim(),
  // .matches(regEx.phone, "Phone number must only contain numbers and cannot start with 0")
  // .length(10, "Phone number must be exactly 10 digits")
  // .required("Phone number is a required field"),

  empPassword: yup
    .string()
    .test(
      "betweenSpaces",
      "Password has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(8, "Password must be more than 8 characters")
    .max(16, "Password cannot exceed more than 16 characters")
    .required("Password is a required field"),

  vendorUserName: yup
    .string()
    .trim()
    // .matches(regEx.name, "User name can only contain alphabets")
    .test(
      "betweenSpaces",
      "User name has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(2, "User name must be more than 2 characters")
    .max(100, "User name cannot exceed more than 100 characters")
    .required("User name is a required field"),

  code: yup.string().trim().required("Vendor code is a required field"),

  vendorUserEmail: yup
    .string()
    .test(
      "betweenSpaces",
      "Email address has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )

    .matches(regEx.email, "Invalid email address format")
    .min(2, "Email address must be more than 2 characters")
    .max(100, "Email address cannot exceed more than 100 characters")
    .required("Email address is a required field")
    .email("Email address has an excessive number of intermediate spaces"),

  vendorUserPhone: yup
    .string()
    .matches(/^\d+$/, "Phone number must only contain numbers")
    .matches(
      /^[1-9]\d{9}$/,
      "Phone number must be exactly 10 digits and cannot start with 0"
    )
    .required("Phone number is a required field")
    .trim(),
  // .matches(regEx.phone, "Phone number must only contain only numbers and cannot start with 0")
  // .length(10, "Phone number must be exactly 10 digits")
  // .required("Phone is a required field"),

  vendorUserPassword: yup
    .string()
    .test(
      "betweenSpaces",
      "Password has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(8, "Password must be more than 8 characters")
    .max(16, "Password cannot exceed more than 16 characters")
    .required("Password is a required field"),

  dataType: yup.string().required("Data type is a required field"),
  formula: yup.string().required("Formula is a required field"),
  roleId: yup.string().required("Role is a required field"),
  processID: yup.string().required("Process is a required field"),
  teamID: yup.string().required("Team is a required field"),
  amount: yup.number().required("Amount is a required field"),
  tripTime: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Trip time must be a number eg: 60 (1Hr)"),
  rolePermissions: yup
    .array()
    .min(1, "You should select at least one permission")
    .required("Permissions is a required field"),
  selectedLanguages: yup.array().min(1, "Select at least one language"),
  defaultLanguage: yup.object().required("Select the default language"),
  selectedCurrencies: yup.array().min(1, "Select at least one currency"),
  defaultCurrency: yup.object().required("Select the default currency"),
  campaignStatus: yup.string().required("Campaign status is a required field"),
  biddingStrategyType: yup.string().required("Bidding is a required field"),
  location: yup.string().required("Location is a required field"),
  targetRoas: yup.string().required("Target Roas is a required field"),
  employeeCodesTripReq: yup
    .string()
    .required("Employee Codes is a required field"),
  state: yup
    .string()
    .transform((value) => (value?.value ? value.value : value))
    .required("State is a required field"),

  configName: yup
    .string()
    .min(2, "Min 2 characters")
    .required("Name is a required field"),
  configValue: yup.string().required("Config value is a required field"),
  defaultValue: yup.string().required("Default value is a required field"),

  adGroupName: yup
    .string()
    .test(
      "betweenSpaces",
      "The adGroupName has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(2, "Ad group name must be more than 2 characters")
    .max(30, "Ad group name cannot exceed more than 30 characters")
    .required("Ad group name is a required field"),
  adgroupType: yup.string().required("Ad group type is a required field"),
  adGroupStatus: yup.string().required("Ad group status is a required field"),
  callout: yup
    .array()
    .min(1, "You should select at least one callout")
    .of(
      yup.object({
        selectedType: yup.string().required("Language is a required field"),
        callOutText: yup
          .string()
          .required("Hotel Callout Text is a required field"),
      })
    ),
  callOut: yup.array().of(
    yup.object({
      selectedType: yup.string().required("Language is a required field"),
      callOutText: yup
        .string()
        .required("Hotel Callout Text is a required field"),
    })
  ),
  secretKey: yup
    .string()
    .test(
      "betweenSpaces",
      "Secret key has an excessive number of intermediate spaces",
      (value: any) => {
        if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
          return false;
        } else {
          return true;
        }
      }
    )
    .min(1, "Secret key must be more than 2 characters")
    .required("Secret key is a required field"),
  aadharNumber: yup
    .string()
    .matches(/^\d{12}$/, "Aadhar number must be 12 digits long and numeric")
    .required("Aadhar number is required"),

  logoutTime: yup
    .string()
    .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "Invalid time format (HH:MM)")
    .test("not-past-time", "Time cannot be in the past", function (value) {
      if (!value) return true; // Skip if empty (not required)
      const now = dayjs();
      const inputTime = dayjs(value, "HH:mm");

      return inputTime.isAfter(now, "minute");
    })
    .test(
      "after-login-time",
      "Drop Time must be later than Pick up Time",
      function (value) {
        const { loginTime } = this.parent;
        if (!value || !loginTime) return true; // skip if either empty
        const login = dayjs(loginTime, "HH:mm");
        const logout = dayjs(value, "HH:mm");
        return logout.isAfter(login, "minute");
      }
    ),

  loginTime: yup
    .string()
    .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "Invalid time format (HH:MM)")
    .test("not-past-time", "Time cannot be in the past", function (value) {
      if (!value) return true; // Skip if empty (not required)
      const now = dayjs();
      const inputTime = dayjs(value, "HH:mm");

      return inputTime.isAfter(now, "minute");
    }),

  //   formImage: yup
  //     .mixed()
  //     .nullable()
  //     .test(
  //       "file-size-and-type",
  //       "Accepted Image Formats: JPG, PNG, GIF. Max File Size: 2MB",
  //       (value) => {
  //         if (!value) {
  //           return true;
  //         }
  //   formImage: yup
  //     .mixed()
  //     .nullable()
  //     .test(
  //       "file-size-and-type",
  //       "Accepted Image Formats: JPG, PNG, GIF. Max File Size: 2MB",
  //       (value) => {
  //         if (!value) {
  //           return true;
  //         }

  //         if (typeof value !== "string") {
  //           const file = value as File;
  //           const isValidType = validateImageTypes(file);
  //           const isValidSize = file.size <= 2000000;
  //           if (isValidType && isValidSize) {
  //             return true;
  //           } else {
  //             return false;
  //           }
  //         }
  //         if (typeof value !== "string") {
  //           const file = value as File;
  //           const isValidType = validateImageTypes(file);
  //           const isValidSize = file.size <= 2000000;
  //           if (isValidType && isValidSize) {
  //             return true;
  //           } else {
  //             return false;
  //           }
  //         }

  //         return false;
  //       }
  //     )
  //     .test(
  //       "file-resolution",
  //       "Image resolution must be 328x150 pixels.", // Custom message for resolution validation
  //       async (value) => {
  //         if (!value || typeof value === "string") {
  //           return true; // Let the 'required' validation handle empty values
  //         }
  //         return false;
  //       }
  //     )
  //     .test(
  //       "file-resolution",
  //       "Image resolution must be 328x150 pixels.", // Custom message for resolution validation
  //       async (value) => {
  //         if (!value || typeof value === "string") {
  //           return true; // Let the 'required' validation handle empty values
  //         }

  //         // Function to check the resolution
  //         const file = value as File;
  //         const dimensions = await getImageDimensions(file);
  //         // Function to check the resolution
  //         const file = value as File;
  //         const dimensions = await getImageDimensions(file);

  //         // Check if the resolution matches 328x150 pixels
  //         return dimensions.width === 326 && dimensions.height === 154;
  //       }
  //     ),
  //         // Check if the resolution matches 328x150 pixels
  //         return dimensions.width === 326 && dimensions.height === 154;
  //       }
  //     ),
};

export const getValidationSchema = (fields: string[]) => {
  const newValidationSchema: any = {};

  fields.map((fieldName) => {
    newValidationSchema[fieldName] = validationSchema[fieldName];
  });

  return yup.object().shape(newValidationSchema);
};

  export const getSimpleCutoffValidationSchema = () =>
  yup.object({
    mode: yup.string().required("Mode is required"),

    minutes: yup.string().when("mode", {
      is: "cutoff",
      then: (schema) =>
        schema.required("Cutoff time is required").matches(/^\d+$/, "Only numbers are allowed"),
    }),

    dailyType: yup.string().when("mode", {
      is: "daily",
      then: (schema) => schema.required("Cutoff type is required"),
    }),

    cutoffTime: yup.string().when("mode", {
      is: "daily",
      then: (schema) => schema.required("Cutoff time is required"),
    }),
  });

export const getCutoffValidationSchema = () =>
  yup.object({
    mode: yup.string().required("Mode is required"),

    lowerCutoff: yup.string().when("mode", {
      is: (mode: string) => mode === "hourly",
      then: schema => schema.required("Lower cutoff is required")
        .matches(/^\d+$/, "Only numbers are allowed"),
    }),

    upperCutoff: yup.string().when("mode", {
      is: (mode: string) => mode === "hourly",
      then: schema => schema.required("Upper cutoff is required")
        .matches(/^\d+$/, "Only numbers are allowed"),
    }),

    dailyType: yup.string().when("mode", {
      is: (mode: string) => mode === "daily",
      then: schema => schema.required("Cutoff type is required"),
    }),

    dayOfWeek: yup.string().when("mode", {
      is: "weekly",
      then: schema => schema.required("Cutoff day is required"),
    }),

    weekStart: yup.string().when("mode", {
      is: "weekly",
      then: schema => schema.required("Week start is required"),
    }),

    dayOfMonth: yup.string().when("mode", {
      is: "monthly",
      then: schema =>
        schema
          .required("Day of month is required")
          .matches(/^\d+$/, "Only numbers are allowed")
          .test(
            "day-of-month-range",
            "Day must be between 1 and 31",
            value => {
              if (!value) return false;
              const day = Number(value);
              return day >= 1 && day <= 31;
            }
          ),
    }),

    cutoffTime: yup.string().when("mode", {
      is: (mode: string) => mode === "weekly" || mode === "monthly" || mode === "daily",
      then: schema => schema.required("Cutoff time is required"),
    }),
  });



export const generateDynamicValidationSchema = (
  fields: string[],
  key1: string,
  key2: string
) => {
  const newValidationSchema: any = {},
    newObject: any = {};

  fields?.map((fieldName) => {
    const formattedFieldName = formatFieldError(fieldName);
    newObject[fieldName] = yup
      .string()
      .test(
        "betweenSpaces",
        `${formattedFieldName} has an excessive number of intermediate spaces`,
        (value: any) => {
          if (value?.trim()?.match(regEx.tooManySpace)?.length > 0) {
            return false;
          } else {
            return true;
          }
        }
      )
      .min(2, `${formattedFieldName} must be more than 2 characters`)
      .required(`${formattedFieldName} is a required field`);
  });

  newValidationSchema[key1] = yup
    .array()
    .of(yup.object({ [key2]: yup.object(newObject) }));

  return yup.object().shape(newValidationSchema);
};
